import BaseValidator from 'services/validations/base-validator';

class LockedGamesValidator extends BaseValidator {
    protected runValidation(): void {
        if (this.areAllGamesLocked()) {
            this.addError('All games are locked.');
        }
    }
    private areAllGamesLocked(): boolean {
        // @ts-ignore
        const {games} = this.dependencies;

        for (const game of games.getAllAsArr()) {
            if (!game.isLocked) {
                return false;
            }
        }

        return true;
    }
}

export default LockedGamesValidator;
